export default __webpack_public_path__ + "static/media/picto-check.fe920d94.svg";